import React, {useEffect, useState} from "react";
import Dialog from '@material-ui/core/Dialog';
import {getstates, getversionapp, starthome} from "../api/api";
import CloseIcon from '@material-ui/icons/Close';
import IconButton from '@material-ui/core/IconButton';
import Button from '@material-ui/core/Button';
import CircularProgress from '@material-ui/core/CircularProgress';
import {makeStyles} from '@material-ui/core/styles';
import {blue, green, purple} from "@material-ui/core/colors";
import withReactContent from 'sweetalert2-react-content';
import Swal from 'sweetalert2';

const useStyles = makeStyles((theme) => ({
    root: {
        '&:hover': {
            backgroundColor: 'transparent',
        },

        '&.MuiIconButton-root': {

            padding: 2,

        },


    },
    icon: {
        borderRadius: '50%',
        width: 16,
        height: 16,
        boxShadow: 'inset 0 0 0 1px rgba(16,22,26,.2), inset 0 -1px 0 rgba(16,22,26,.1)',
        backgroundColor: '#f5f8fa',
        backgroundImage: 'linear-gradient(180deg,hsla(0,0%,100%,.8),hsla(0,0%,100%,0))',
        '$root.Mui-focusVisible &': {
            outline: '2px auto rgba(19,124,189,.6)',
            outlineOffset: 2,
        },
        'input:hover ~ &': {
            backgroundColor: '#ebf1f5',
        },
        'input:disabled ~ &': {
            boxShadow: 'none',
            background: 'rgba(206,217,224,.5)',
        },
    },
    checkedIcon: {
        backgroundColor: '#137cbd',
        backgroundImage: 'linear-gradient(180deg,hsla(0,0%,100%,.1),hsla(0,0%,100%,0))',
        '&:before': {
            display: 'block',
            width: 16,
            height: 16,
            backgroundImage: 'radial-gradient(#fff,#fff 28%,transparent 32%)',
            content: '""',
        },
        'input:hover ~ &': {
            backgroundColor: '#106ba3',
        },
    },

    avatar: {
        backgroundColor: blue[100],
        color: blue[600],
    },
    red: {

        color: '#f44336',


    },

    underlinetext: {

        fontSize: '0.75rem',
        marginTop: 5,
        color: '#f44336',
        fontFamily: 'iransans',


    },


    borderred: {
        fontFamily: 'iransans',
        border: '1px solid #f44336',
        borderRadius: 4,
        fontSize: 5,


    },
    border: {
        fontFamily: 'iransans',
        border: '1px solid rgba(0, 0, 0, 0.23)',
        borderRadius: 10,
        fontSize: 5,
        marginBottom: 0,
        color: 'rgba(0, 0, 0, 0.54)',


        "&:hover": {
            cursor: 'pointer'
        },


    },

    borderselected: {
        fontFamily: 'iransans',
        border: '1px solid #152e84',
        borderRadius: 10,
        fontSize: 5,
        backgroundColor: '#152e84',
        marginBottom: 0,
        color: 'rgba(0, 0, 0, 0.54)',

        "&:hover": {
            cursor: 'pointer'
        },

    },


    paper: {
        width: '80%',
        maxHeight: 435,
    },

    sendpic: {
        margin: '0 auto',
        marginBottom: 15,
        textAlign: 'center',
        '&:hover': {
            cursor: 'pointer',
        },
    },

    button: {
        fontSize: 18,
        fontWeight: 'bold',
        height: 43,
        width: '100%',
        fontFamily: 'iransans',
        color: '#dadada',
        backgroundColor: '#3f51b5',
        '&:hover': {
            backgroundColor: '#172b95',
        },
    },

    input2: {
        fontFamily: 'iransans',
        width: '100%'
    },
    input: {
        fontFamily: 'iransans',
        width: '100%',
        marginTop: 15
    },
    formControl: {
        fontFamily: 'iransans',
        width: '100%',
        marginBottom: 15,

    },

    wrapper: {
        marginTop: 15,
        position: 'relative',
    },
    buttonSuccess: {
        fontSize: 18,
        fontWeight: 'bold',
        height: 43,
        width: '100%',

        fontFamily: 'iransans',
        color: '#dadada',
        backgroundColor: green[500],
        '&:hover': {
            backgroundColor: green[700],
        },
    },

    buttonProgress: {
        color: green[500],
        position: 'absolute',
        top: '50%',
        left: '50%',
        marginTop: -12,
        marginLeft: -12,
    },

    iconButton: {
        padding: 10,
        fontSize: 15,
        fontFamily: 'iransans'
    },
    divider: {
        height: 28,
        margin: 4,
    },

    direction: {
        direction: 'rtl',
        width: 150,
        height: 40
    },

    fontright: {
        fontFamily: 'iransans',
        textAlign: 'right',
        marginRight: 10,
        width: 100
    },
    fontleft: {
        fontFamily: 'iransans',
        textAlign: 'right',
        marginLeft: 10
    }

    ,
    center: {

        flex: 1,
        justifyContent: 'center',
        alignItems: 'center'

    },
    margin: {

        width: 50,
        height: 25,
        textAlign: 'center'


    },
    textBox: {
        "& $div": {
            justifyContent: "center",
            "& $input": {
                width: "30%"
            }
        },
        "& $p": {
            alignSelf: "center"
        }
    },
    inputremove: {

        textAlign: 'center',


        '&:focus': {
            backgroundColor: 'transparent',
            outline: 'none'
        },


    }


}));


const MySwal = withReactContent(Swal);
const DialogClose3 = (props) => {

    const classes = useStyles();


    // const [dialog, setDialog] = useState(true);


    useEffect(() => {
        if (props.open) {
            MySwal.fire({
                title: props.title,
                text: props.body,
                icon: 'warning',
                showCancelButton: true,
                confirmButtonText: 'اندروید',
                cancelButtonText: 'IOS',
                reverseButtons: true,
                allowOutsideClick: false,
                showCloseButton: true,
                willClose: () => {
                    props.close();
                },
            }).then(result => {
                if (result.value) {
                    // MySwal.showLoading();
                    props.yes();
                    // firedandroidinstalled();
                    // MySwal.fire({
                    //     title: 'در حال پردازش',
                    //     didOpen: () => {
                    //         MySwal.showLoading()
                    //
                    //     },
                    // });
                    //
                    // setTimeout(() => {
                    //     MySwal.hideLoading();
                    //
                    // }, 2000);
                    // // alert('sdd');


                    // MySwal.fire('Deleted!', 'Your file has been deleted.', 'success');
                } else if (
                    /* Read more about handling dismissals below */
                    result.dismiss === Swal.DismissReason.cancel
                ) {
                    props.cancel();
                    // MySwal.fire('Cancelled', 'Your imaginary file is safe :)', 'error');
                }
            });
        } else {
            MySwal.hideLoading();
            MySwal.close();
            // MySwal.fire('Deleted!', 'Your file has been deleted.', 'success');
        }


    }, [props.open]);

    useEffect(() => {
        if (props.loader3 && props.open) {
            MySwal.fire({
                title: 'در حال خروج',
                didOpen: () => {
                    MySwal.showLoading()

                },
            });
        }


    }, [props.loader3]);

    // const handleRequestClose = (value) => {
    //     setDialog(false);
    //
    // };


    return (
        <div></div>

        // <Dialog open={props.open} onClose={() => props.cancel()}>
        //
        //     <div style={{
        //         display: 'flex', justifyContent: 'start',
        //         alignItems: 'start', flexDirection: 'column'
        //     }}>
        //
        //
        //         <div style={{
        //             display: 'flex', justifyContent: 'space-between',
        //             alignItems: 'center', width: '100%'
        //         }}>
        //
        //             <div style={{marginBottom: 10, marginTop: 10, marginRight: 10, fontFamily: 'iransans'}}>
        //                 {props.title}
        //             </div>
        //
        //             <IconButton onClick={() => props.cancel()} aria-label="Close">
        //                 <CloseIcon/>
        //             </IconButton>
        //         </div>
        //
        //
        //         <div style={{
        //             width: 300,
        //             marginBottom: 20,
        //             padding: 10,
        //             fontFamily: 'iransans',
        //             fontSize: 10,
        //             fontWeight: 'bold'
        //         }}>
        //             {props.body}
        //         </div>
        //
        //
        //         <div style={{
        //             display: 'flex', justifyContent: 'center',
        //             alignItems: 'center', width: '100%', marginBottom: 20
        //         }}>
        //
        //             <Button disabled={props.loader} onClick={() => props.yes()} variant="contained"
        //                     className="bg-primary text-white iran-font"
        //                     style={{width: 60}}>
        //                 بله
        //
        //                 {props.loader &&
        //                 <CircularProgress size={24} className={classes.buttonProgress}/>}
        //
        //             </Button>
        //             <Button onClick={() => props.cancel()} variant="contained"
        //                     className="bg-primary text-white iran-font"
        //                     style={{width: 60, marginRight: 10}}>
        //                 انصراف
        //             </Button>
        //
        //
        //         </div>
        //
        //
        //         {/*<div style={{overflow: 'hidden',flex:0.8}}>*/}
        //         {/*<div style={{overflowY: 'scroll'}}>*/}
        //
        //
        //         {/*</div>*/}
        //         {/*</div>*/}
        //
        //
        //     </div>
        //
        //
        // </Dialog>


    );


};


export default DialogClose3;







